import React from 'react';
import {Button} from "@mui/material";
import {FormattedMessage} from "react-intl";
import CancelIcon from '@mui/icons-material/Cancel';

type CloseButtonProps = {
    onClick: () => void;
    color?: string;
};

const CloseButton: React.FC<CloseButtonProps> = (props) => {

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        props.onClick();
    }

    return (
        <Button
            variant="outlined"
            size="small"
            // @ts-ignore
            color={props.color || "secondary"}
            startIcon={<CancelIcon/>}
            onClick={(e) => handleClick(e)}>
            <FormattedMessage id={'COMMON_CLOSE'}/>
        </Button>
    );
};
export default CloseButton;
